import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {featuresSetupUpdateFeatures} from "./featuresActions";
import PropTypes from "prop-types";
import CheckBox from "../PageLayout/CheckBox";
import {featureInterface} from "./FeaturesSetupFeature/featureInterface";


const FeaturesSetupTopPanelLeftSelectItem = (props) => {

  const {featuresSetupUpdateFeatures, intlKey, itemFeatures} = props;

  const checked = itemFeatures.every(feature => feature.selected);

  const selectCheckboxClick = () => {
    featuresSetupUpdateFeatures("selected", !checked, itemFeatures)
  };

  return (
    <li className="select3-dropdown__list-item select3-dropdown__list-item--with-checkbox">
      <span className={"select3-dropdown__list-item-text select3-dropdown__list-item-text--no-hover"}>
        <FormattedMessage id={intlKey}/>
      </span>
      <CheckBox checked={checked}
                innerStyle="none"
                colorClass="dark"
                onChecked={selectCheckboxClick}
                text=""/>
    </li>
  )
};

FeaturesSetupTopPanelLeftSelectItem.propTypes = {
  intlKey: PropTypes.string.isRequired,
  itemFeatures: PropTypes.arrayOf(PropTypes.shape(featureInterface)).isRequired,
}

const mapDispatchToProps = {
  featuresSetupUpdateFeatures,
};

export default connect(null, mapDispatchToProps)(FeaturesSetupTopPanelLeftSelectItem)
